import axios from '~/clients/axios';
import { NEW_CAR_CONFIGURATION } from '~/constants/endpoints';
import type {
  ConfigurationRequest,
  ResponseForRequest
} from '~/contracts/new-cars';

export default function fetchNewCarConfiguration<
  R extends ConfigurationRequest
>(
  request: R,
  requestType: string,
  controller: AbortController
): Promise<ResponseForRequest<R>> {
  return axios
    .post(NEW_CAR_CONFIGURATION, request, {
      headers: { 'x-request-type': requestType },
      signal: controller.signal
    })
    .then(res => res.data);
}
